import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { AttributeString, attributeStringEnumParser } from '~app-ui-new/utils';

export enum LayoutIconTextVariant {
	SIZE_M = 'SIZE_M',
	SIZE_L = 'SIZE_L',
	SIZE_XL = 'SIZE_XL',
}

const VARIANT_TO_TEXT_CLASS: Record<LayoutIconTextVariant, string> = {
	[LayoutIconTextVariant.SIZE_M]: 'pl-0.5',
	[LayoutIconTextVariant.SIZE_L]: 'pl-1',
	[LayoutIconTextVariant.SIZE_XL]: 'pl-1.5',
};

const DEFAULT_TEXT_CLASS = 'pl-1';

@Component({
	selector: '[uiNewLayoutIconText]',
	templateUrl: './icon-text.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [CommonModule],
	host: {
		class: 'w-full flex ',
	},
})
export class UiNewLayoutIconText {
	private _variant: LayoutIconTextVariant | null = null;

	@HostBinding('class')
	@Input('uiNewLayoutIconText')
	public set variant(variant: AttributeString<LayoutIconTextVariant>) {
		this._variant = attributeStringEnumParser(variant, LayoutIconTextVariant, null);
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		this.textClass = VARIANT_TO_TEXT_CLASS[this.variant] ?? DEFAULT_TEXT_CLASS;
	}

	public get variant() {
		return this._variant as AttributeString<LayoutIconTextVariant>;
	}

	public textClass = DEFAULT_TEXT_CLASS;
}
